import { Component, OnInit } from "@angular/core";
import * as _ from 'lodash';
import { DetailsPathTarget } from "../custom-table-column/custom-table-column";
import { DynamicDetailsLinkTableColumn } from "../custom-table-column/dynamic-details-link-table-column";
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'dynamic-details-link-table-value',
    template: `<span [ngClass]="(elementId && detailsUrl) ? 'highlight' : null" (click)="goToDetails($event)">{{ getValue() }}</span>`
})
export class DynamicDetailsLinkTableValueComponent extends CustomTableValueComponent<DynamicDetailsLinkTableColumn> implements OnInit {

    private elementId: string;
    private elementType: DetailsPathTarget;
    private detailsUrl: string;

    ngOnInit(): void {
        this.elementId = _.get(this.element, this.column.idPath);
        this.elementType = _.get(this.element, this.column.typePath);
        this.detailsUrl = this.getDetailsUrl(this.elementType);
    }

    goToDetails($event): void {
        $event.stopPropagation();
        this.navigationService.navigateTo([this.detailsUrl, this.elementId]);
    }

}